/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'

class UnMatchCardex extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      unmatch: []
    }
  }

  componentDidMount() {
    const token = sessionStorage.getItem('accessToken')
    http
      .get(`${WAREHOUSE.WAREHOUSE_REPORT_INCOMPLATIBLE_CARDEXREMAIN}?export=true`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            unmatch: response.data.object.result
          })
        } else {
          message.success(response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  render() {
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>انبار</li>
            <li>مغایرت موجودی و کاردکس</li>
          </ul>
          <div className="tableComponent">
            <table className="baseTable">
              <tbody>
                <tr className={'firstRow'}>
                  <td>ردیف</td>
                  <td>نام محصول</td>
                  <td>کد محصول</td>
                  <td>بارکد محصول</td>
                  <td>نام انبار</td>
                  <td>تعداد کاردکس</td>
                  <td>تعداد موجودی</td>
                </tr>
                {this.state.unmatch.map((unmatch, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{unmatch.productName}</td>
                    <td>{unmatch.articleId}</td>
                    <td>{unmatch.productCode}</td>
                    <td>{unmatch.warehouseName}</td>
                    <td>{unmatch.cardexQuantity}</td>
                    <td>{unmatch.remainQuantity}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }
}

export default UnMatchCardex
